<template>
  <!-- prettier-ignore -->
  <div
    v-if="preSaleActive"
    class="bandana-v7-teaser position-relative"
    style="background: repeat center center url('https://img.fortawesome.com/1ce05b4b/tablecloth-pattern3.png'),linear-gradient(135deg, var(--fa-yellow), var(--fa-dk-yellow)); overflow: hidden;"
  >
    <div class="container">
      <div class="row roomy">
        <div class="column-12 padding-y-xl padding-x-0 margin-left-xl tablet:margin-left-0">
          <div class="display-flex">
            <div class="column-1 align-middle align-center display-flex">
              <font-awesome-icon
                :icon="$v6.solid.faCircle7"
                size="2x"
              />
            </div>
            <div
              class="column-11 tablet:display-flex align-between align-middle"
              style="--button-margin-bottom: 0"
            >
              <div>
                <h2 class="h4 margin-top-0 margin-bottom-4xs">Introducing Font Awesome 7!</h2>
                <p class="padding-right-2xl tablet:padding-right-0">
                  Coming in June 2025.
                  <button
                    class="link flat"
                    style="--button-padding: 0; --button-color: var(--fa-navy); --button-hover-color: var(--fa-dk-blue); --button-decoration: underline"
                    @click.prevent="$emit('show-livestream-modal')"
                  >
                    Watch the Announcement
                  </button>
                </p>
              </div>
              <div class="margin-top-lg tablet:margin-top-0">
                <a
                  href="/#fa7"
                  class="button flat with-border"
                  style="
                    --button-color: var(--fa-navy);
                    --border-color: var(--fa-dk-yellow);
                    --button-background: var(--fa-yellow);
                    --button-hover-background: var(--fa-dk-yellow);
                  "
                >
                  <font-awesome-icon
                    :icon="$v6.solid.faSparkles"
                    size="lg"
                    class="padding-right-xs"
                  />See What's New
                </a>
                <site-link
                  :to="{ name: 'plans' }"
                  class="button flat with-border"
                  style="
                    --button-color: var(--fa-navy);
                    --border-color: var(--fa-dk-yellow);
                    --button-background: var(--fa-yellow);
                    --button-hover-background: var(--fa-dk-yellow);
                  "
                >
                  <font-awesome-icon
                    :icon="$v6.solid.faTag"
                    size="lg"
                    class="padding-right-xs"
                  />{{ daysLeft }} {{ formatPlural(daysLeft, 'Day') }} Left to Save!
                </site-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import pluralize from 'pluralize'
  import { timeToPreSaleEnd } from 'app/views/timerUtils'
  import { v7PreSaleStatus } from 'app/views/plans/PlansData'

  export default {
    name: 'V7PrereleaseNotice',

    data() {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        preSaleActive: v7PreSaleStatus.preSaleActive
      }
    },

    computed: {
      daysLeft() {
        return timeToPreSaleEnd().days
      }
    },

    methods: {
      formatDate(date) {
        return date.toFormat('MMMM d, yyyy')
      },

      formatPlural(number, word) {
        return pluralize(word, number)
      }
    }
  }
</script>
